import React, { Fragment } from "react";
import { Button } from "react-bootstrap";

const BApprovalButton = ({ onClick, title }) => {
    return (
        <Fragment>
            <Button variant="link" onClick={onClick} style={{ margin: 0, padding: 0 }}>
                {title}
            </Button>
        </Fragment>
    );
};

BApprovalButton.defaultProps = {
    onClick: null,
    title: "View Status"
};

export default BApprovalButton;
